<template>
  <div>
    <v-alert
      class="ml-0 mb-0 mr-0"
      text
      :icon="data.icon"
      :color="data.color"
      ><div :class="getCustomCssClass(data)" ><ParagraphBlock :html="data.content"></ParagraphBlock>  </div>
</v-alert>
  </div>
</template>

<script>

import ParagraphBlock from "./paragraphBlock.vue"

export default {
  name: "ColoredNotificationBlock",
  props: ["data"],
  data: () => ({
  }),
  components: {ParagraphBlock},
  mounted(){
    console.log(this.data, "text from colored")
  },
  methods:{
    getCustomCssClass(data) {
      if (data.custom_css_override !== null) {
        console.log(
          "getCustomCssClass()",
          data.custom_css_override
        );
        return data.custom_css_override;
      }
      return "";
    },
  }
};
</script>

<style scoped>
</style>